























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import DeskDto from '@/models/Desks/DeskDto';
import UpdateDeskGeneralDetailsRequest from '@/models/Desks/UpdateDeskRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'DeskEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new DeskDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentDesk));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get businessHours() {
    return AgencySettingsModule.businessHours;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateDeskGeneralDetailsRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.businessHoursId = this.entity.businessHours.id;

    await AgencySettingsModule.editDeskGeneralDetails(request)
    this.dialog = false;
  }
}
